import * as css from 'css/exports.module.scss';
import './PardotRule.scss';
import { ifClickHandler } from '@lib/events';
import { lowerFirst } from '@sonar-software/sonar-ts-lib';
import { SonarRecord } from '@ui/records';
import { Col, Row, Typography } from 'antd';
import React, { useMemo } from 'react';
const { Title } = Typography;
export const PardotRule = ({ entity, onRuleClick }) => {
    const { description, displayName, sonarObjectId, sonarObjectType } = entity;
    const ruleReferenceType = lowerFirst(entity.sonarObjectType);
    const clickable = Boolean(sonarObjectType) && Boolean(sonarObjectId);
    const handleOnClick = useMemo(() => ifClickHandler(onRuleClick, entity), [entity, onRuleClick]);
    const formattedDisplayName = useMemo(() => {
        if (!(displayName === null || displayName === void 0 ? void 0 : displayName.includes('\n'))) {
            return displayName;
        }
        return displayName === null || displayName === void 0 ? void 0 : displayName.split('\n').map((entry) => {
            const [title, value] = entry.split(':');
            if (!value) {
                return title.trim();
            }
            const formattedTitle = `${title === null || title === void 0 ? void 0 : title.trim()}: `;
            return (React.createElement(React.Fragment, { key: entry },
                React.createElement("strong", null, formattedTitle),
                value,
                React.createElement("br", null)));
        });
    }, [displayName]);
    return (React.createElement("div", { className: 'pardot-rule' },
        React.createElement(Row, { align: 'middle', gutter: Number(css.size4), justify: 'space-between', wrap: false },
            React.createElement(Col, { flex: 'none' },
                React.createElement(Title, { className: 'rule-label', level: 4 }, description))),
        React.createElement(SonarRecord, { name: formattedDisplayName, onClick: clickable ? handleOnClick : undefined, sonarObjectId: sonarObjectId, sonarObjectType: ruleReferenceType })));
};
